import { Box, Typography } from "@mui/material"
import { numberFormat } from "../../../utils/nunberFormat"
import { useTranslation } from "react-i18next"

/*
    #C4EAFF
    #C8FACD
    #FFACB6
*/
interface Props {
    title: string
    countNumber: number
    bgColor: string
}


const StatusComponents = ({ title, countNumber, bgColor }: Props) => {
    const { t } = useTranslation('global')

    return (
        <Box sx={{
            backgroundColor: bgColor, borderRadius: '16px', p: 4, boxShadow:
                '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
        }}>
            <Box>
                <Typography sx={{ mb: 1 }}>{title}</Typography>
                <Typography fontWeight="bold" fontSize={32}>{numberFormat(countNumber)} {t("Mr_manage.users")}</Typography>
            </Box>
        </Box >
    )
}
export default StatusComponents